module.exports = __webpack_public_path__ + "img/emoji-49.45128084.png";